import PropTypes from 'prop-types'
import React from 'react'
import { InputField } from 'components'
import { Card, CardBody, CardFooter } from 'reactstrap'
import { Form, Formik } from 'formik'
import LoaderButton from 'components/molecules/loader-button'
import ToggleField from 'components/molecules/toggle-field'

const propTypes = {
  noticebar    : PropTypes.object,
  handleSubmit : PropTypes.func.isRequired,
  isSubmitting : PropTypes.bool
}

/**
 * @param {Object} noticebar
 * @param {Function} handleSubmit
 * @param {boolean} isSubmitting
 */
const CmsNoticebarEditForm     = ({
  noticebar,
  handleSubmit
}) => (
  <Formik
    enableReinitialize={ true }
    initialValues={{
      id             : noticebar.id || '',
      is_active      : noticebar.is_active      || false,
      title          : noticebar.title          || '',
      content        : noticebar.content        || '',
      is_link_active : noticebar.is_link_active || false,
      link_text      : noticebar.link_text      || '',
      link_url       : noticebar.link_url       || ''
    }}
    onSubmit={ (values, formikBag) => handleSubmit(values, formikBag) }
  >
    {
      (formikBag) => (
        <Form>
          <Card>
            <CardBody>
              <ToggleField
                type={ 'checkbox' }
                id={ 'is_active' }
                name={ 'is_active' }
                label={ 'Is Active' }
                formText={ 'Turning this off will remove the noticebar from Shopfront' }
              />
              <InputField
                type='text'
                name='title'
                label='Title'
                required={ true }
                formText='Title of your notice. Keep this short.'
              />
              <InputField
                type='textarea'
                rows='5'
                name='content'
                label='Content'
                required={ true }
                formText='Details of your notice.'
              />
              <ToggleField
                type={ 'checkbox' }
                id={ 'is_link_active' }
                name={ 'is_link_active' }
                label={ 'Is Link Active' }
                required={ true }
                formText='To display the button to link. Set to false if there is no link'
              />
              <InputField
                type='text'
                name='link_text'
                label='Link Text'
                required={ true }
                formText='Text you want to display on the link (e.g. "Shop Now", "View Collection")'
              />
              <InputField
                type='text'
                name='link_url'
                label='Link URL'
                required={ true }
                formText='URL when user clicks on the link text.'
              />
            </CardBody>
            <CardFooter>
              <LoaderButton
                color='success'
                isLoading={ formikBag.isSubmitting }
                text={ 'Save' }
                className='float-right'
                type='submit'
              />
            </CardFooter>
          </Card>
        </Form>
      )
    }
  </Formik>
)
CmsNoticebarEditForm.propTypes = propTypes

export default CmsNoticebarEditForm